export default {
  input: {},
};
